export const CART_CHANGED_MODAL = 'CART_CHANGED_MODAL'
export const ERROR_MODAL = 'ERROR_MODAL'
export const LOGIN_MODAL = 'LOGIN_MODAL'
export const REORDER_MODAL = 'REORDER_MODAL'